import { HandlerProps } from '../../../../store/synchronousMiddleware';
import { RouterActionTypes } from '../../../../types/actions/router';
import RoutesRedirectionFactory from '../../../../utils/routes/RoutesRedirectionFactory';
import { LineUpActionTypes } from '../../types/actions/lineUp';

let awaitingMatchLoaded: number | null = null;

export const handledActionTypes = [RouterActionTypes.ROUTE_HAS_CHANGED, LineUpActionTypes.PROGRESSIVELY_OPEN_VIEW];

const lineUpMiddlewareHandler = ({ action, params: { history } }: HandlerProps) => {
  const { payload = {} } = action;

  if (handledActionTypes.indexOf(action.type) !== -1) {
    if (action.type === LineUpActionTypes.PROGRESSIVELY_OPEN_VIEW) {
      const { matchId } = payload;

      if (matchId) {
        history.push(RoutesRedirectionFactory.getMatchRouteConfig(matchId));
        awaitingMatchLoaded = matchId;
      }
    }

    if (action.type === RouterActionTypes.ROUTE_HAS_CHANGED) {
      const { pathname } = payload;

      if (awaitingMatchLoaded && pathname && `/match/${awaitingMatchLoaded}`.match(pathname)) {
        setTimeout(() => {
          if (awaitingMatchLoaded) {
            history.push(RoutesRedirectionFactory.getLineUpRouteConfig(awaitingMatchLoaded));
            awaitingMatchLoaded = null;
          }
        }, 200);
      }
    }
  }
};

export default lineUpMiddlewareHandler;
